import { Link, Typography, useTheme } from "@mui/material";
import NextLink from "next/link";
import React from "react";
export const Menu = ({ items }) => {
    const theme = useTheme();
    return (React.createElement("ul", { style: { listStyleType: "none", padding: 0, margin: 0 } }, items.map(({ external = false, label, route }) => {
        const props = external
            ? {
                target: "_blank",
                rel: "noopener noreferrer",
            }
            : {};
        const LinkComponent = external ? Link : NextLink;
        return (React.createElement("li", { key: `footer-${label}-${route}`, style: { padding: `${theme.spacing(0.45)} 0` } },
            React.createElement(Typography, { component: "div", color: "secondary", variant: "body1", sx: {
                    "&:hover": { opacity: 0.75 },
                    m: 0,
                    p: 0,
                    transition: theme.transitions.create("opacity"),
                }, ...props },
                React.createElement(LinkComponent, { ...props, href: route, style: { color: "inherit" } }, label))));
    })));
};
//# sourceMappingURL=menu.js.map